import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { _AuxLiquidation, _Exportations, _NationalizationProcessGeneralInfo } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { AuxLiquidationItems } from "./AuxLiquidationItems/AuxLiquidationItems";








export const AuxLiquidation = () => {

    const AuxLiquidation = useDataBean(_AuxLiquidation);
    const generalinfobycost = useDataBean(_NationalizationProcessGeneralInfo);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [pathfile, setPathFile] = useState<string>('');
    const [modalitem, setModalitem] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldescargar, setDescargar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        AuxLiquidation.instance.getAuxLiquidationCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        AuxLiquidation.setBean({
            State: 1,
            IDEmployee: single.getAccountID(),
            Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        AuxLiquidation.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        AuxLiquidation.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAuxLiquidation', visible: true },
        { title: 'Valor total de transporte', property: 'TotalTransportValue', visible: true },
        { title: 'Total peso bruto', property: 'TotalGrossWeight', visible: true },
        { title: 'Peso neto total', property: 'TotalNetWeight', visible: true },
        { title: 'Valor total del seguro', property: 'TotalInsuranceValue', visible: true },
        { title: 'Bultos', property: 'TotalBulks', visible: true },
        { title: 'Estado', property: 'State', visible: true },
        { title: 'Fecha del registro', property: 'Since', visible: true },
        // { title: 'ID de los aranceles', property: 'IDTaxPosition', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Items', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalitem({ ...modalitem, "view": true }) } },
            { titulo: 'Descargar Reporte', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setDescargar({ ...modaldescargar, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const descargar = () => {
        generalinfobycost.instance.ExportExcelWithDataAuxLiq(AuxLiquidation.bean.IDAuxLiquidation).then(
            (resp: any) => {

                let fullPath = resp || "";
                console.log(fullPath);

                let fileName = fullPath.split("/").pop();

                console.log(fileName);

                let path = "/quickdataerp/temp/docs/" + fileName;
                setPathFile(path);
            }
        )

    }



    return (
        <BasicPage titulo="Auxiliar de Liquidación">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={AuxLiquidation.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Valor total de FOB</label>
                                        <input type="text" name="TotalFobValue" className="form-control" value={AuxLiquidation.bean.TotalFobValue} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Valor total de transporte</label>
                                        <input type="text" name="TotalTransportValue" className="form-control" value={AuxLiquidation.bean.TotalTransportValue} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Total peso bruto</label>
                                        <input type="text" name="TotalGrossWeight" className="form-control" value={AuxLiquidation.bean.TotalGrossWeight} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Peso neto total</label>
                                        <input type="text" name="TotalNetWeight" className="form-control" value={AuxLiquidation.bean.TotalNetWeight} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Valor total del seguro</label>
                                        <input type="text" name="TotalInsuranceValue" className="form-control" value={AuxLiquidation.bean.TotalInsuranceValue} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Total Bultos</label>
                                        <input type="text" name="TotalBulks" className="form-control" value={AuxLiquidation.bean.TotalBulks} onChange={AuxLiquidation.handleChange} />
                                    </div>
                                </div>

                            </div>

                        </>
                    </Modal>
                    <Modal modal={modalitem} updateModal={setModalitem}>
                        <>
                            <div className="row">
                                <AuxLiquidationItems IDAuxLiquidation={AuxLiquidation.bean.IDAuxLiquidation} />
                            </div>

                        </>
                    </Modal>
                    <Modal modal={modaldescargar} updateModal={setDescargar} eventModal={editaItem}>
                        <>

                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargar() }}>Auxiliar de Liquidación</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}